// DesktopPagination component
export default function () {
    return {
        path: '',

        init() {
            this.path = this.$root.dataset.path;
            this.$root.querySelectorAll('.jumper').forEach((element) => element.setAttribute('x-popover.html', 'jumper'));
        },

        jumper() {
            return {
                title: __('pagination.jump_to'),
                content: document.getElementById('pagination_jumper_popover').innerHTML,

                allowList: {
                    input: ['type'],
                    button: [],
                },

                customClass: 'pagination-jumper-popover',

                data: {
                    owner: this,
                    params: {},
                    page: 1,
                    maxPage: this?.data?.meta?.last_page,

                    bind: {
                        'x-on:keyup.escape.document': 'close',
                        'x-intersect:leave': 'close',
                    },

                    init() {
                        this.params = Helper.getSearchParams({ page: 1 });
                        this.page = this.params.page;
                        this.$root.setAttribute('x-bind', 'bind');
                        this.$nextTick(() => this.$refs.page.select());
                    },

                    jump() {
                        if (this.page === this.params.page) {
                            this.close();

                            return;
                        }

                        const url = new URL(window.location.origin + this.owner.path);

                        if (typeof this.owner.load === 'function') {
                            this.owner.load(url.href, { page: Math.max(1, Math.min(this.page, this.maxPage)) });
                        } else {
                            url.search = new URLSearchParams(Object.assign({}, this.params, { page: Math.max(1, this.page) }));

                            if (typeof window.Bolt !== 'undefined') {
                                window.Bolt.go(url);
                            } else {
                                window.location.href = url;
                            }
                        }

                        this.close();
                    },
                },
            };
        },
    };
}
